import ChatHeader from "./ChatHeader";
import MessageList from "./MessageList";
import MessageInput from "./MessageInput";
import TypingIndicator from "./TypingIndicator";
import EmptyState from "./EmptyState";
import "./styles/ChatMain.scss";
import botImage from '../../assets/images/hedgehog.png';
import { SpinnerPage } from "../global/Spinner";
import { useChatMain } from "../../hooks/useChatMain";
import { getRecipientId, getTypingName } from "../../utils/chatParticipants";

const ChatMain = ({
  selectedChatId,
  onBackClick,
  isMobileView,
  currentSystemUser,
  chatInfo,
  onRefreshSidebar,
  showProfile,
  setSelectedSenderId,
  showSheet,
  openSheet,
  isLoadingMessages,
  setIsLoadingMessages,
  isAdmin,
  blockedUserIds = []
}) => {
  const { messages, cardsData, isTyping, typingUserId, socket, sendError, handleSendMessage, handleAddMessage, handleTyping } = useChatMain({
    selectedChatId,
    currentSystemUser,
    setSelectedSenderId,
    setIsLoadingMessages
  });

  const isBotChat = !chatInfo?.isGroup;
  const recipientId = getRecipientId(chatInfo, currentSystemUser?.userId, isAdmin);
  const isBlockedChat = !!recipientId && blockedUserIds.includes(recipientId);
  const hasNotice = isBlockedChat || !!sendError;
  const typingName = getTypingName(messages, typingUserId);
  const hasMessages = cardsData.length > 0 || messages.length > 0;
  const headerUser = {
    name: chatInfo?.name ?? "",
    profileImageUrl: isBotChat ? botImage : (chatInfo?.profileImageUrl || "/images/profileImage.png"),
    secondeImageUrl: chatInfo.secondeImageUrl
  };
  const mainChatClassName = showProfile ? "mainChantWithProfile" : "mainChat";
  const mainChatStyle = !showSheet ? { width: "100%" } : {};

  if (isLoadingMessages) return <SpinnerPage />;

  return (
    <section className={mainChatClassName} style={mainChatStyle}>
      <ChatHeader
        isBot={isBotChat}
        currentUser={headerUser}
        onBackClick={onBackClick}
        isMobileView={isMobileView}
        openSheet={openSheet}
        isAdmin={isAdmin}
      />
      {hasMessages ? (
        <div className={hasNotice ? "messageContainer messageContainer--withNotice" : "messageContainer"}>
          <MessageList
            isBotChat={isBotChat}
            openSheet={openSheet}
            setSelectedSenderId={setSelectedSenderId}
            messages={messages}
            recipientId={recipientId}
            cardsData={cardsData}
            onAddMessage={(msg) => handleAddMessage(msg, onRefreshSidebar)}
          />
          {/* スクロールする一覧の中だと下端に隠れるため、一覧の外（入力欄の上）に出す */}
          <TypingIndicator isTyping={isTyping} name={typingName} />
          {isBlockedChat && (
            <p className="chatMain__notice" role="status">ブロック中のため送信できません</p>
          )}
          {!isBlockedChat && sendError && (
            <p className="chatMain__notice" role="alert">{sendError}</p>
          )}
          <MessageInput
            onSendMessage={handleSendMessage}
            onTyping={handleTyping}
            socket={socket}
            selectedChatId={selectedChatId}
            isDisabled={isBotChat || isBlockedChat}
          />
        </div>
      ) : (
        <EmptyState message="データがありません" />
      )}
    </section>
  );
};

export default ChatMain;